import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/login", name: "Login", component: () => import("../views/Login.vue"), meta: { public: true } },
    { path: "/agreement", name: "UserAgreement", component: () => import("../views/LegalDocument.vue"), meta: { public: true, legalDocument: "agreement" } },
    { path: "/privacy", name: "PrivacyPolicy", component: () => import("../views/LegalDocument.vue"), meta: { public: true, legalDocument: "privacy" } },
    { path: "/paid-service-agreement", name: "PaidServiceAgreement", component: () => import("../views/LegalDocument.vue"), meta: { public: true, legalDocument: "paidServiceAgreement" } },
    {
      path: "/",
      component: () => import("../layout/UserLayout.vue"),
      children: [
        { path: "", redirect: "/devices" },
        { path: "dashboard", redirect: "/devices" },
        { path: "devices", name: "Devices", component: () => import("../views/Devices.vue"), meta: { title: "我的设备" } },
        { path: "devices/:product/series/:seriesId", name: "SeriesSettings", component: () => import("../views/SeriesSettings.vue"), meta: { title: "套系管理" } },
        { path: "devices/:product/:deviceNo/settings", name: "DeviceSettings", component: () => import("../views/DeviceSettings.vue"), meta: { title: "设备设置" } },
        { path: "chat/:product/:deviceNo", name: "DeviceChat", component: () => import("../views/DeviceChat.vue"), meta: { title: "聊天记录" } },
        { path: "knowledge", name: "Knowledge", component: () => import("../views/Knowledge.vue"), meta: { title: "我的知识库" } }
      ]
    }
  ]
});

router.beforeEach((to) => {
  if (!to.meta.public && !localStorage.getItem("allfo-user-token")) {
    return { name: "Login", query: { redirect: to.fullPath } };
  }
  if (to.name === "Login" && localStorage.getItem("allfo-user-token")) return { name: "Devices" };
});

export default router;
